import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode } from 'react';

import { PreferencesProvider } from './PreferencesProvider';
import { ThemeProvider } from './ThemeProvider';

import { queryClient } from '@/lib/queryClient';

/**
 * The application's composition root.
 *
 * One place where the global providers are assembled, in an explicit order.
 * Tests and Storybook reuse this component rather than rebuilding an
 * approximate stack of their own.
 *
 * Warning: i18next is absent on purpose: it is initialised **before** rendering, in
 * `main.tsx`, which spares every screen a "translations not loaded yet" state.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <PreferencesProvider>{children}</PreferencesProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
